import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_standart_template = _resolveComponent("standart-template")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "px-4 py-2" }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-medium" }, "Частые вопросы", -1)),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqTabs, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-3 flex flex-col rounded-md bg-greyLight px-6 py-4",
            onClick: ($event: any) => (item.isOpen = !item.isOpen)
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(item.title), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["transition-all", { 'rotate-180': item.isOpen }])
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
              ]))], 2)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              (item.isOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.answer), 1))
                : _createCommentVNode("", true)
            ])), [
              [_directive_auto_animate, { duration: 150 }]
            ])
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}